<template>
  <el-dialog append-to-body width="550px" title="详情" v-if="visible" :visible.sync="visible"
             :before-close="handleClose">
    <el-descriptions v-loading="loading" :column="1">
      <el-descriptions-item label="营业执照">
        <el-image :src="list.businessLicense" :preview-src-list="srcList"/>
      </el-descriptions-item>
      <el-descriptions-item label="印模图">
        <div class="flex-center-between">
          <el-image :src="list.sealMark" :style="{width : sealWidth + 'mm' ,height : sealHeight + 'mm'}"
                    :preview-src-list="srcList"/>

          <img src="@/assets/replacement.png" alt="" v-if="list.sealImage"/>

          <el-image v-if="list.sealImage" :src="list.sealImage"
                    :style="{width : sealWidth + 'mm' ,height : sealHeight + 'mm'}" :preview-src-list="srcList"/>
        </div>
      </el-descriptions-item>
    </el-descriptions>

    <el-upload
        style="display: none"
        ref="upload"
        class="image-box"
        :show-file-list="false"
        :before-upload="(e,list) => handleUploadSuccess(e,list)"
        :on-change="onChangeFront"
        accept="image/*,.std"
        action="/"
    >
    </el-upload>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()">取 消</el-button>
      <el-button v-if="!list.imageId" type="primary" @click="handleReplacement()">替换印模图</el-button>
      <el-button v-if="list.imageId" type="primary" @click="handleSubmit()">确认</el-button>
    </span>

  </el-dialog>
</template>

<script>

import {auth} from "@/utils/auth";
import {request} from "@/utils/request";

export default {
  name: "orderDetails",
  computed: {
    request() {
      return request
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      list: {},
      sealWidth: '',
      sealHeight: '',
      srcList: [],
      sealType: '',
      sealBelongCode: '',
      uploadFileUrl: process.env.VUE_APP_API_BASE_URL + "/kq/index/getSecretSealImage",
      headers: {
        'Authorization': auth.getKqToken(),
      },
    }
  },
  methods: {
    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleUploadSuccess(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.loading = true
        this.$http.post(this.$api.register.upload, {
          type: this.sealType,
          imageBase64: base,
          businessCode: this.sealBelongCode,
          width: this.sealWidth,
          height: this.sealHeight
        }).then((res) => {
          this.$set(this.list, 'sealImage', "data:image/jpeg;base64," + base)
          this.$set(this.list, 'imageId', res.data.data.imageId)
          this.srcList.push(this.list.sealImage)
          this.loading = false
        }).catch((err) => {
          this.$message.error('印模图上传失败');
          this.loading = false
        });
      };
      return false; // 阻止默认上传行为
    },
    handleReplacement() {
      this.$refs.upload.$el.querySelector('input[type=file]').click()
    },
    handleSubmit() {
      this.$confirm('此操作将会替换印模图, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http.post(this.$api.customerEnterprise.replaceSealMark, {
          id: this.id,
          sealMarkId: this.list.imageId
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '替换成功!'
            });
            this.handleClose()
            this.loading = false
          } else {
            this.$message.error(res.data.msg);
            this.handleClose()
          }

        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消替换'
        });
      });
    },
    getOrderDetails(id) {
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.getDataInfo, {id: id}).then(res => {
        if (res.data.code == 200) {
          this.list = {
            businessLicense: "data:image/png;base64," + res.data.data.businessLicense,
            sealMark: "data:image/png;base64," + res.data.data.sealMark,
          }
          this.srcList = ["data:image/png;base64," + res.data.data.businessLicense, "data:image/png;base64," + res.data.data.sealMark,]
          this.loading = false
        } else {
          this.$message.error(res.data.msg);
          this.handleClose()
        }

      })
    },
    show(e) {
      this.visible = true
      this.sealWidth = e.sealWidth
      this.sealHeight = e.sealHeight
      this.sealBelongCode = e.sealBelongCode
      this.id = e.id
      this.sealType = e.sealType
      this.list = {}
      this.getOrderDetails(e.id)
    },
    handleClose() {
      this.visible = false;
    }
  }
}
</script>

<style scoped lang="less">

</style>
